import { Xmark } from "iconoir-react";

import { createIcon } from "../create-icon";

export const IconXmark12Line = createIcon(Xmark, 12, "Line");
export const IconXmark16Line = createIcon(Xmark, 16, "Line");
export const IconXmark20Line = createIcon(Xmark, 20, "Line");
export const IconXmark24Line = createIcon(Xmark, 24, "Line");
export const IconXmark32Line = createIcon(Xmark, 32, "Line");
export const IconXmark48Line = createIcon(Xmark, 48, "Line");
export const IconXmark64Line = createIcon(Xmark, 64, "Line");
